import { FC } from 'react';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';
import { useCartQuery } from '@telialt/core-eshop/src/hooks/queries/useCartQuery';
import {
    selectDiscountPrice,
    selectIsFullPricePayment,
    selectLeasingDiscountPrice,
} from '@telialt/utils/src/eshopSelectors';
import { withParams } from '@telialt/utils/src/helpers';

import { BadgeStyled } from './PredefinedLeasingSelector.styles';

export const DiscountBadge: FC = () => {
    const { t } = useTranslations();
    const { cart } = useCartQuery();
    const productDiscountPrice = selectDiscountPrice(cart);
    const leasingDiscountPrice = selectLeasingDiscountPrice(cart);
    const isFullPricePayment = selectIsFullPricePayment(cart);
    const discountPrice = isFullPricePayment ? productDiscountPrice : leasingDiscountPrice;

    if (!discountPrice?.value) {
        return null;
    }

    return (
        <BadgeStyled variant="special">
            {withParams(t['eshop.product_page.leasing_selector.discount'], {
                discount: discountPrice.formattedValue,
            })}
        </BadgeStyled>
    );
};
